/*
 * Code related to tables and responsive tables.
 */
var TableController = (function ($) {

	var ret, win;

	function ready() {
		win = $(window);
		fixRawTables();
		addHeaderAttrsToTableRows("table.data");

		if (BreakpointController.isMobile()) {
			fixDataTableHeights();
			win.on('load resize', fixDataTableHeights);
		}
	}

	function fixDataTableHeights() {
		fixHeights.apply($("table.data tbody tr td"));
	}

	function fixHeights() {
		$(this).each(function () {
			var td = $(this),
				title = td.children('.header-title'),
				value = td.children('.field-value');

			// Remove current inline height

			title.add(value).css('height', '');
			var h1 = title.outerHeight(),
				h2 = value.outerHeight();

			title.add(value).css('height', Math.max(h1, h2));
		});
	}

	/*
	 * For each regular table, make it look like a data table if it's within a content area.
	 */
	function fixRawTables() {
		$("section.content .content table").not('.data').each(function () {
			var table = $(this);
			var klass = table.attr('class');

			// If class attr is blank, add the data class.
			if (!klass || /^\s*$/gi.test(klass)) {
				table.addClass('data');
				addMissingThead.apply(table);
			}
		});
	}

	// If a table doesn't have a thead element in it, make it so by grabbing the first row and turning the td into a th or using the th if it's there.
	function addMissingThead() {
		var table = $(this),
			tbody = table.find('tbody'),
			thead = table.find('thead');

		// If there's already a thead then don't bother.	
		if (thead.length > 1) return;

		// Create a new thead
		thead = $("<thead><tr></tr></thead>");
		var theadTr = thead.children('tr');

		var firstRow = tbody.children('tr').first();
		firstRow.children('th').each(function () {
			var th = $(this);
			theadTr.append(th);
		});
		firstRow.children('td').each(function () {
			var td = $(this),
				th = $("<th />");
			th.html(td.html());
			theadTr.append(th);
		});

		firstRow.remove();
		table.prepend(thead);
	}

	/*
	 * For each table, add attributes containing the header titles to the 
	 * td elements in the row so the CSS has access to the title value when 
	 * using the smaller stacked layout.
	 */
	function addHeaderAttrsToTableRows(selector) {
		$(selector).each(function () {
			var table = $(this),
				headers = [];
			$('thead th', table).each(function (i, el) {
				var header = $(this);
				headers.push(header.attr('data-small-title') || header.html().trim());
			});
			$("tbody > tr", table).each(function () {
				var row = $(this),
					cols = row.children('td'),
					table = row.closest('table'),
					headerColumnCount = table.find('thead th').length;

				cols.each(function (i) {
					var td = $(this),
						colspan = parseInt(td.attr('colspan'));

					td.attr('data-header-title', headers[i] || "");

					if (BreakpointController.isMobile()) {
						var isFullWidthBlock = !!(colspan && colspan === headerColumnCount);

						// Reset the content back to what it was before.
						var html = '';
						var existingFieldValue = td.children('.field-value');
						// If there's an existing field value, use that element's .html() value.
						if (existingFieldValue.length > 0) {
							html = existingFieldValue.html();
						}
							// Otherwise, just use the .html() value of the element itself.
						else {
							html = td.html();
						}
						// Destroy whatever's in there because we have the value saved at this point.
						td.html('');

						// If it's not a full width block, add the header title.
						if (!isFullWidthBlock) {
							var title = $("<span class='header-title' />");
							title.html(headers[i]);
							td.append(title);
						}

						var fieldValue = $("<span class='field-value' />");
						if (isFullWidthBlock) {
							fieldValue.addClass('full');
						}
						fieldValue.html(html);
						td.append(fieldValue);
					}
				});
			});
		});
	}

	$(ready);

	ret = {
		fixDataTableHeights: fixDataTableHeights
	};
	return ret;

})(jQuery);